<template>
  <div>
    <div class="flex justify-between mb-4">
      <h2 class="text-2xl font-bold">Users</h2>
      <base-button @click="inviteOpen = !inviteOpen">
        <span v-if="inviteOpen">Close</span>
        <span v-else><icon-plus /> Invite user</span>
      </base-button>
    </div>

    <AdminUsersForm v-if="inviteOpen" @add-new="addUser" />

    <div v-if="fetchingUsers" class="text-blue-400">
      <base-loading class="block text-3xl" />
      Loading
    </div>
    <template v-else>
      <ul class="my-12">
        <li v-for="companyRole in acceptedUsers" :key="companyRole.id">
          <div class="flex bg-white mb-1">
            <div class="flex-1 flex justify-between py-2 px-4">
              {{ companyRole.user_email }}
              <strong>{{ companyRole.role }}</strong>
            </div>
            <base-button @click="companyRole.editing = !companyRole.editing">
              <icon-edit />
            </base-button>
          </div>
          <AdminUsersForm
            v-if="companyRole.editing"
            :companyRole="companyRole"
            @edit="updateUser(companyRole.id, $event)"
          />
        </li>
      </ul>
      <div v-if="invitedUsers.length">
        <h3 class="text-lg mb-4">Pending</h3>
        <ul class="mb-8">
          <li v-for="companyRole in invitedUsers" :key="companyRole.id">
            <div class="flex bg-white mb-1">
              <div class="flex-1 flex justify-between py-2 px-4">
                {{ companyRole.user_email }}
                <strong>{{ companyRole.role }}</strong>
              </div>
              <base-button @click="resendInvitation(companyRole.id)"
                >Resend</base-button
              >
              <base-button
                @click="companyRole.editing = !companyRole.editing"
                class="ml-1"
              >
                <icon-edit />
              </base-button>
            </div>
            <AdminUsersForm
              v-if="companyRole.editing"
              :companyRole="companyRole"
              @edit="updateUser(companyRole.id, $event)"
            />
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AdminUsersForm from './components/AdminUsersForm';

export default {
  components: {
    AdminUsersForm,
  },
  data() {
    return {
      fetchingUsers: false,
      fetchingInvitations: false,
      inviteOpen: false,
      companyRoles: [],
    };
  },
  computed: {
    ...mapState({
      currentCompanyId: (state) => state.company.currentId,
    }),
    acceptedUsers() {
      return this.companyRoles.filter((companyRole) => companyRole.accepted);
    },
    invitedUsers() {
      return this.companyRoles.filter((companyRole) => !companyRole.accepted);
    },
  },
  watch: {
    currentCompanyId() {
      this.fetchCompanyRoles();
    },
  },
  created() {
    this.fetchCompanyRoles();
  },
  methods: {
    async fetchCompanyRoles() {
      this.fetchingUsers = true;
      const { data } = await this.$api.get(
        `companies/${this.currentCompanyId}/user_company_roles/`,
        {
          cache: {
            ignoreCache: true,
          },
        }
      );
      this.companyRoles = data.map((companyRole) => ({
        ...companyRole,
        editing: false,
      }));
      this.fetchingUsers = false;
    },
    addUser() {
      this.fetchCompanyRoles();
      this.inviteOpen = false;
    },
    updateUser(id, data) {
      this.companyRoles = this.companyRoles.map((companyRole) => {
        if (companyRole.id === id) {
          return {
            ...data,
            editing: false,
          };
        }
        return companyRole;
      });
    },
    resendInvitation(id) {
      this.$api.post(
        `companies/${this.currentCompanyId}/resend_invitation/${id}/`
      );
    },
  },
};
</script>
